import React from 'react'
import '../styles/common.css'

const Partners = () => {
  return (
    <section className='partners'>
        <h1>Supported By</h1>
        <img src='./assets/logos/maan-logo.png' alt="ma'an logo"></img>
    </section>
  )
}

export default Partners
